///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
namespace TotalContest {
    import Controller = TotalCore.Common.Controller;
    import SettingsService = TotalCore.Common.Providers.SettingsService;
    import IScope = angular.IScope;

    @Controller('controllers.totalcontest')
    export class SubmissionCtrl {
        constructor(private $scope: IScope, private SettingsService: SettingsService) {
            $scope.settings = SettingsService.settings;
            $scope.information = SettingsService.information;
        }
    }

}